<!-- components/MessageCard.vue -->
<template>
  <component :is="link && !disable ? 'router-link' : 'div'" :to="link && !disable ? link : null">
    <div class="message-card" :class="cardClass">
      <h4>{{ title }}</h4>
      <span><slot /></span>
    </div>
  </component>
</template>

<script>
export default {
  props: {
    title: String,
    link: [String, Object],
    active: Boolean,
    disable: Boolean,
  },
  computed: {
    cardClass() {
      return {
        active: this.active,
        'message-card-disable': this.disable,
      }
    }
  }
}
</script>
